import {
  type ConversationCatalogItemComponent,
  type ConversationDetailA2uiBlock,
  type ConversationDetailBlock,
  type ConversationDetailSection,
} from './ConversationTurnItem'
import { deriveSourceChannel, SourceChannels } from './deriveSourceChannel'
import {
  ConversationDetailBlockTypes,
  ConversationDetailSectionIds,
} from '../enums'

const isA2uiBlock = (
  block: ConversationDetailBlock
): block is ConversationDetailA2uiBlock =>
  block.type === ConversationDetailBlockTypes.A2UI

export const canHaveSupplierWidget = (item: ConversationCatalogItemComponent) =>
  item.itemId !== '' &&
  deriveSourceChannel(item.vendor) === SourceChannels.AMAZON

export const findSupplierWidgetBlock = (
  sections: ConversationDetailSection[]
): Nullable<ConversationDetailA2uiBlock> =>
  sections
    .find(
      (section) => section.id === ConversationDetailSectionIds.SUPPLIER_DETAILS
    )
    ?.blocks.find(isA2uiBlock) ?? null
